import React from 'react';
import Icon from './Icon';

/**
 * 4-stage horizontal timeline row (Sent → Viewed → Signed → Completed).
 *
 * Props:
 *   stages  – array of { label, meta?, state: 'done'|'active'|'blocked'|'pending' }
 *   compact – smaller dots, no labels
 */
const TimelineRow = ({ stages = [], compact = false }) => {
  const size = compact ? 16 : 20;
  return (
    <div className="flex items-center w-full">
      {stages.map((s, i) => {
        const isDone    = s.state === 'done';
        const isActive  = s.state === 'active';
        const isBlocked = s.state === 'blocked';
        const dotSize   = size + 8;

        return (
          <React.Fragment key={i}>
            <div className="flex flex-col items-center" style={{ minWidth: compact ? 48 : 64 }}>
              <div
                className={`flex items-center justify-center rounded-full transition-colors
                  ${isDone    ? 'bg-leaf-500 text-white' : ''}
                  ${isActive  ? 'bg-ink-700 text-white ring-4 ring-ink-700/10' : ''}
                  ${isBlocked ? 'bg-flame-500 text-white' : ''}
                  ${!isDone && !isActive && !isBlocked ? 'bg-paper-200 text-ink-300 ring-1 ring-inset ring-ink-100' : ''}
                `}
                style={{ width: dotSize, height: dotSize }}
              >
                {isDone    && <Icon name="check" size={size - 6} strokeWidth={2.4} />}
                {isActive  && <div className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" />}
                {isBlocked && <Icon name="x"     size={size - 6} strokeWidth={2.4} />}
                {!isDone && !isActive && !isBlocked && (
                  <div className="w-1 h-1 rounded-full bg-ink-300" />
                )}
              </div>

              {!compact && (
                <div className="mt-1.5 text-center">
                  <div className={`text-[11px] font-semibold leading-tight ${isDone || isActive ? 'text-ink-800' : 'text-ink-400'}`}>
                    {s.label}
                  </div>
                  {s.meta && (
                    <div className="text-[10px] text-ink-400 tnum">{s.meta}</div>
                  )}
                </div>
              )}
            </div>

            {i < stages.length - 1 && (
              <div className="flex-1 h-px mx-1 relative">
                <div className="absolute inset-0 bg-ink-100" />
                {isDone && (
                  <div
                    className="absolute inset-0 bg-leaf-400"
                    style={{
                      clipPath:
                        stages[i + 1].state === 'done' || stages[i + 1].state === 'active'
                          ? 'inset(0 0 0 0)'
                          : 'inset(0 50% 0 0)',
                    }}
                  />
                )}
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default TimelineRow;
